/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <div class="expire">密码有效期还有
      :{{expire}}天  (记得定期更换密码保证账号安全性)</div>
    <el-submenu index="2" class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title">{{username}}</template>
      <el-menu-item index="2-1" @click="setting()">设置</el-menu-item>
      <!--<el-menu-item @click="content()" index="2-2">个人中心</el-menu-item>-->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout,expireTime } from '../api/userFun'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      username: '',
      expire:0,
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    let uid=localStorage.getItem('uid');
    
    this.expireDay();
    
    this.$store.dispatch('getuserName',uid).then(res=>{
       // console.log(this.$store.state.userNameData);
        this.username = this.$store.state.userNameData;
       
    });
   
  },
  methods: {
    expireDay(){
      expireTime().then(res=>{

    //    console.log(parseInt(new Date('2024-03-01').getTime()));
        let days;
        let expireTimeTamp = parseInt(new Date(res.data).getTime()/1000);
        let nowTimestamp = parseInt(new Date().getTime()/1000); 
        let TimeTamp =expireTimeTamp-nowTimestamp;  
        if(TimeTamp>0){
          days= Math.ceil(TimeTamp/(3600*24));
        }else{
           days=0;
        }
        this.expire=days
      })
    },
    setting(){
      this.$router.push({
        path:'/setting/password'
      })
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            localStorage.removeItem('Authorization');
            sessionStorage.removeItem('permission');
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  },
  
}
</script>
<style scoped>

.expire{
  color: #f56c6c;
  display: inline-block;
  text-align: center;
  width: 500px;
  margin: 0 auto;
  font-weight:500;
  

}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue